export default __webpack_public_path__ + "static/media/expand.f127e649.svg";